import { useState } from 'react'
import { heapEvent } from '@equipmentshare/heaper'

import {
	EuiButton,
	EuiButtonEmpty,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'

import ProductClassForm, { ProductClassFormState } from '../../ProductClassForm'
import useCreateProductClassHandler from '../../../effects/createProductClass'
import validateForm from '../../ProductClassForm/helpers/validateForm'

export type AddProductClassModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
}

export default function AddProductClassModal( { onCancel, onSuccess }: AddProductClassModalProps ) {
	const [ formState, setFormState ] = useState<ProductClassFormState>( {
		catClass: '',
		categoryName: '',
		classification: '',
		validation: {
			catClass: { isInvalid: false },
			categoryName: { isInvalid: false },
			classification: { isInvalid: false },
		},
	} )
	const [ isSaving, setIsSaving ] = useState( false )
	const createProductClass = useCreateProductClassHandler()

	const handleCancel = () => {
		heapEvent( 'Inventory - Add Product Class Modal - Click - Cancel', {} )
		onCancel()
	}

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Add Product Class Modal - Click - Submit', {} )
		setIsSaving( true )

		const { isInvalid, newFormState } = validateForm( formState )
		if ( isInvalid ) {
			setFormState( newFormState )
			setIsSaving( false )
		} else {
			try {
				await createProductClass( formState.catClass, formState.categoryName, formState.classification )
			} catch ( e: unknown ) {
				setIsSaving( false )
			}
			onSuccess()
		}
	}

	return (
		<>
			<EuiModalBody>
				<ProductClassForm
					formState={formState}
					setFormState={setFormState}
				/>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButtonEmpty
					color="text"
					id="cancelBtn"
					onClick={handleCancel}
				>
					Cancel
				</EuiButtonEmpty>
				<EuiButton
					id="submitBtn"
					fill
					isLoading={isSaving}
					onClick={handleSubmit}
				>
					Add class
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
